<template>
  <div class="phone_footer" :style="{backgroundColor:color}">
      <div class="fot_cent">

            <p class="copyright">Copyright © 北京语你悦动信息技术有限公司</p>

            <p class="mail">
                <span>客服邮箱： kefu@uummii.life</span>&nbsp;&nbsp;
                <span>商务邮箱： hezuo@uummii.life</span>
            </p>

            <p class="protalList">
                <span class="protaltxt" @click="goto">营业执照</span><span class="linespine">|</span>
                <span class="protaltxt" @click="gotopro(11)">儿童隐私政策</span><span class="linespine">|</span>
                <span class="protaltxt" @click="gotopro(10)">用户隐私协议</span><span class="linespine">|</span>
                <span class="protaltxt" @click="gotopro('vhtml')">用户注册协议</span><span class="linespine">|</span>
                <span class="protaltxt" @click="gotopro('chtml')">用户购买协议</span>
            </p>

            <p class="iplist">
                <span>京ICP备2020044017号-2</span>&nbsp;&nbsp;
                <span><img class="police" :src="getpath('/index/police','.png')" alt="">&nbsp;京公网安备：11010502044833  </span>
            </p>
            <div class="imglist">
                <img class="record_1" :src="getpath('/index/record_1','.png')" alt="">
                <img class="record_2" :src="getpath('/index/record_2','.png')" alt="">
                <img class="record_3" :src="getpath('/index/record_3','.png')" alt="">
                <img class="record_4" :src="getpath('/index/record_4','.png')" alt="">
            </div>
      </div>
 
  </div>
</template>

<script>
export default {
    props:['color','ispro'],
    data(){
        return {

         }
    },
    methods:{
        goto(){
            window.location.href = 'https://www.uummii.life/static/images/License.jpg'
        },
        gotopro(keyword){
            if(this.ispro){
                this.$emit('getContent',keyword)
                return;
            }
            this.$router.push({name:"protacal",query:{type:keyword}})

        }
    }
}
</script>

<style lang="scss" scoped>
    .phone_footer{
        width: 100%;
        height: 200px;
        margin: 0px auto;
        color: white;
        padding-top: 20px;
        padding-bottom: 20px;
        position: relative;
        z-index: 999;
        display: flex;
        justify-content: center;
        flex-flow: row wrap;
        align-content: space-around;
        .fot_cent{
            width: 750px;
            margin: 0 auto;

            .copyright{
                font-size: 22px;
                text-align: center;
            }
            .mail{
                font-size: 20px;
                text-align: center;
                margin-top: 6px;
            }
            .protalList{
                font-size: 20px;
                text-align: center;
                margin-top: 6px;
                .linespine{
                    margin-left: 5px;
                }

            }
            .iplist{
                font-size: 20px;
                text-align: center;
                margin-top: 6px;
                .police{
                    width: 15px;
                    height: 17px;
                }
            }
            .imglist{
                width: 100%;
                height: 30px;
                display: flex;
                flex-flow: row nowrap;
                justify-content: center;
                align-items: baseline;
                margin-top: 6px;
                .record_1{
                    width: 86px;
                    height: 29px;
                    margin-right: 20px;
                }
                .record_2{
                    width: 89px;
                    height: 30px;
                    margin-right: 20px;
                }
                .record_3{
                    width: 84px;
                    height: 30px;
                    margin-right: 20px;
                }
                .record_4{
                    width: 85px;
                    height: 30px;
                }

            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/footer.vue